import { resetFocus } from "owa-mail-focus-manager";
import { getSelectedTableView, type TableQueryType, MailRowDataPropertyGetter } from "owa-mail-list-store";
import { lazyShowSweepDialog } from "owa-mail-sweep-view";
import { getIsSharedMailbox } from "owa-shared-mailbox";
import type { MailboxInfo } from "owa-client-types";
import { logUsage } from "owa-analytics";
import getEffectiveRowKeys from "owa-mail-list-store/lib/utils/getEffectiveRowKeys";
import { getMailboxInfo } from "owa-mail-mailboxinfo";

export default function onSweep(mailboxInfo: MailboxInfo, targetWindow?: Window, itemId?: string, source?: string): void {
    const tableView = getSelectedTableView(true /* shouldGetEffectiveTableView */);
    if (!tableView) {
        return;
    }
    const rowKeys = getEffectiveRowKeys(tableView);
    let itemIdForSweep: string | undefined = itemId;
    
    // In a popout, mailboxInfo is derived from itemId.mailboxInfo at the ribbon definition layer.
    // In the main window, we derive it from the effective table view (useful for secondary reading pane context if exists).
    const effectiveMailboxInfo = itemId ? mailboxInfo : getMailboxInfo(tableView);
    
    // If it is a search, find the item id from the selected row keys
    if (tableView.tableQuery.type === 1) {
        itemIdForSweep = MailRowDataPropertyGetter.getItemIds(rowKeys[0], tableView)[0];
    }
    
    logUsage("TnS_SweepShowDialog", effectiveMailboxInfo, { source });
    
    getIsSharedMailbox(effectiveMailboxInfo);
    lazyShowSweepDialog.importAndExecute(rowKeys, tableView, effectiveMailboxInfo, targetWindow, itemIdForSweep);
    resetFocus("sweepCommand");
}
